/**
 * Preview widget (?preview=true) : synchronise avec l’API la nav principale
 * sans rebuild ni Redux — lu par layout-base dans `props.location.search`.
 */
export const PREVIEW_DISPLAY_MAIN_NAV_QUERY_PARAM =
  "preview_display_main_navigation" as const;

export function normalizeWidgetDisplayMainNavigation(
  raw: unknown
): boolean {
  if (raw === false || raw === "0" || raw === 0) return false;
  return true;
}

export function serializePreviewDisplayMainNavigationParam(
  displayMainNavigation: boolean
): "0" | "1" {
  return displayMainNavigation ? "1" : "0";
}

/** Retour défini uniquement pour `?preview=true` + query param présent. */
export function parsePreviewDisplayMainNavigationFromLocationSearch(params: {
  search: string;
  isPreview: boolean;
}): boolean | undefined {
  const { search, isPreview } = params;
  if (!isPreview || typeof search !== "string") return undefined;
  const sp = new URLSearchParams(search);
  const raw = sp.get(PREVIEW_DISPLAY_MAIN_NAV_QUERY_PARAM);
  if (raw === null || raw === "") return undefined;
  return !(raw === "0" || raw === "false");
}
